export interface ShareArtifactWithPositionsRequest {
  publicId: string
  positions: { id: string; name?: string; department_id?: number }[]
}
